var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 11C38 12.656 36.656 14 35 14C33.344 14 32.333 12.332 32.333 12.332M32.333 12.332H33.689M32.333 12.332V13.832M32 11C32 9.344 33.332 8 35 8C37.001 8 38 9.668 38 9.668M38 9.668V8.168M38 9.668H36.668",
    stroke: "#020202",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 11,
    r: 6,
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1875 25.875H15.8125C14.2247 25.875 12.9375 27.1622 12.9375 28.75V57.5C12.9375 59.0878 14.2247 60.375 15.8125 60.375H53.1875C54.7753 60.375 56.0625 59.0878 56.0625 57.5V28.75C56.0625 27.1622 54.7753 25.875 53.1875 25.875Z",
    fill: "#2F88FF",
    stroke: "black",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4375 40.25C26.0253 40.25 27.3125 38.9628 27.3125 37.375C27.3125 35.7872 26.0253 34.5 24.4375 34.5C22.8497 34.5 21.5625 35.7872 21.5625 37.375C21.5625 38.9628 22.8497 40.25 24.4375 40.25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5625 40.25C46.1503 40.25 47.4375 38.9628 47.4375 37.375C47.4375 35.7872 46.1503 34.5 44.5625 34.5C42.9747 34.5 41.6875 35.7872 41.6875 37.375C41.6875 38.9628 42.9747 40.25 44.5625 40.25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 46C27.1621 46 25.875 47.2871 25.875 48.875C25.875 50.4629 27.1621 51.75 28.75 51.75V46ZM40.25 51.75C41.8379 51.75 43.125 50.4629 43.125 48.875C43.125 47.2871 41.8379 46 40.25 46V51.75ZM28.75 51.75H40.25V46H28.75V51.75Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35 18L35 25",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 37.375V48.875",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.25 37.375V48.875",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.62f8fd0740df78b85fa6ac6b750264dd.svg";
export { ForwardRef as ReactComponent };